import React from 'react';
import { Link } from 'react-router-dom';

const SimpleLPFooter = () => {
  return (
    <footer className="bg-[#093336] text-white py-8">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <img src="/logo-footer.png" alt="Trademark Inspire" className="h-10 mx-auto mb-3" />
          <p className="text-sm text-gray-300">
            © 2026 Trademark Inspire. All rights reserved.
          </p>
          <div className="flex justify-center gap-4 mt-3 text-sm">
            <Link to="/privacy" className="text-gray-300 hover:text-[#F77F00] transition-colors">
              Privacy Policy
            </Link>
            <span className="text-gray-400">|</span>
            <Link to="/terms" className="text-gray-300 hover:text-[#F77F00] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SimpleLPFooter;
